const files = require.context("./views", true, /\.vue$/)

let ignoreList = ["About", "App", "Home", "SlimTest", "Auth","Login", "Logout", "SlimTest2", "Dashboard","MobileHome","Error404"]

import helper from "@/vueHelper"
////Please look that
//only first file of folder can change order/icon 

const pages = []

export default function getMobilePages  () {
    files.keys().forEach(key => {
        let path = key.replace(/(\.\/|\.vue)/g, '');
        if (ignoreList.includes(path)) {
            return;
        }
    
    
        path = path.replace(/[a-zA-Z]_/, '');
        let name = path
        path = path.replace(/ /g, '');
        // console.log(name);
        let value = files(key).default;
    
        // console.log(path);
        let arr = name.split("/");
        let group1 = arr[0];
        let group2 = null;
        if (arr.length == 1) {
            group2 = null
        } else if (value.isSingle) {
            group2 = null
        } else {
            group2 = arr[2] ? arr[1] : group1;
        }
    
        group1 = helper.getWord(group1);
        group2 = helper.getWord(group2);
       
        // console.log(arr);
    
        let title = helper.getWord(value.title);
        let icon = value.icon ? value.icon : "fas fa-dollar-sign";
        let haveId = helper.isNullOrUndefined(value.haveId) ? true : value.haveId;
        let order = value.order ? value.order : 999;
        let hidden = helper.isNullOrUndefined(value.hidden) ? false : value.hidden;
        let meta = {
            order: order,
            access_code: value.access_code,
            requiresAuth: true,
            hidden: hidden,
            title: title,
            sideBar: {
                group: group1,
                icon: icon,
                detail: group2 ? {
                    group: group2
                } : null
            },
        }
    
        if (value.access_code) {
            pages.push({
                path: "/Mobile/" + path + (haveId ? "/:id?" : ""),
                name: "Mobile"+name,
                component: value,
                meta: meta,
                props: (route) => {
                    // console.warn(route);
                }
            })
        }
    
    
    })
    
    pages.sort((a, b) => a.meta.order - b.meta.order);
    
    return pages.slice();
}
